export type RunKind =
  | "portfolio"
  | "pipeline"
  | "scoring_batch"
  | "autoresearch"
  | "quality_gate"
  | "telemetry";

export type RunStatus = "success" | "partial" | "failed" | "measured";

export interface RunSkillChange {
  name: string;
  before: number | null;
  after: number;
  delta: number | null;
}

export interface RunRecord {
  id: string;
  kind: RunKind;
  label: string;
  timestamp: string;
  gitSha: string | null;
  status: RunStatus;
  source?: string;
  metrics?: Record<string, unknown>;
  delta?: Record<string, unknown> | null;
  skillChanges?: RunSkillChange[];
  log?: string;
  entries?: Array<{
    run: number;
    timestamp: number;
    value: number;
    status: string;
    description?: string;
    skill: string;
  }>;
  flags?: Record<string, unknown>;
  detail?: unknown;
}

export interface WorkflowCatalogEntry {
  id: string;
  file: string;
  name: string;
  actionsUrl: string;
}

export interface RunsBundle {
  generated: string;
  gitSha: string | null;
  summary: { total: number; byKind: Record<string, number> };
  workflows: WorkflowCatalogEntry[];
  runs: RunRecord[];
}

export const RUN_KIND_LABELS: Record<RunKind, string> = {
  portfolio: "Portfolio",
  pipeline: "Pipeline log",
  scoring_batch: "Scoring batch",
  autoresearch: "Autoresearch",
  quality_gate: "Quality gate",
  telemetry: "Telemetry",
};